/**
 * UTC calendar-day bucket for Customer Preview collab (CUS + CON).
 *
 * Single pure SoT: API (`dayIndexForItem` re-export) and UI (`collabDayIndex`)
 * must not drift — bulk Approve day stamps the services the customer saw.
 */

/** Normalise naked Postgres wall-clock strings to UTC ISO. */
const toUtcIso = (raw: string | null | undefined): string | null => {
  if (raw == null || raw.length === 0) return null;
  if (raw.endsWith('Z')) return raw;
  const t = raw.replace(' ', 'T');
  return /\.\d+$/.test(t) ? `${t}Z` : `${t}.000Z`;
};

const utcMidnightMs = (d: Date): number =>
  Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());

/**
 * Which day a service belongs to — version start anchor + UTC calendar-day
 * offset, clamped into 0..durationDays-1.
 */
export const dayIndexForItem = (
  tripStartTime: string | null | undefined,
  itemStartTime: string | null | undefined,
  durationDays: number
): number => {
  const total = Math.max(0, Math.trunc(durationDays));
  if (!itemStartTime || total <= 0) return 0;
  const anchor = new Date(
    toUtcIso(tripStartTime ?? null) ?? '2000-01-01T00:00:00.000Z'
  );
  const at = new Date(toUtcIso(itemStartTime) ?? itemStartTime);
  if (Number.isNaN(anchor.getTime()) || Number.isNaN(at.getTime())) return 0;
  const diff = Math.round(
    (utcMidnightMs(at) - utcMidnightMs(anchor)) / (24 * 60 * 60 * 1000)
  );
  if (diff < 0) return 0;
  if (diff > total - 1) return total - 1;
  return diff;
};
